import { Card, Text } from '@mantine/core';

export function RunNote({ note }: { note: string }) {
  return (
    <Card>
      <Text fw={800}>Run Note</Text>
      <Text>{note}</Text>
    </Card>
  );
}
